module.exports = {
  WEB: 1,
  FILE_IMPORT: 2,
  API: 3,
  GROUP_DISPATCH: 4,
  BULK_REVERSE: 5,
  RETURN_WEB: 6,
  RETURN_PORTAL: 7,
  ECOMMERCE: 8,
  SHIPPING_API: 9,
  RETURN_API: 10,
  META: 11,
};
